import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Link, Typography } from '@mui/material';
import { getVoiceAdminSettings } from '../../../api/backendApi';

const maskSid = (sid) => {
  if (!sid || typeof sid !== 'string') return '—';
  if (sid.length <= 8) return sid;
  return `${sid.slice(0, 4)}…${sid.slice(-4)}`;
};

export default function TwilioAccountTab() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const refresh = async () => {
    setLoading(true); setError('');
    try {
      const resp = await getVoiceAdminSettings();
      setData(resp?.data || resp || {});
    } catch (e) {
      setError(String(e?.message || 'Failed to load account info'));
    } finally { setLoading(false); }
  };

  useEffect(() => { refresh(); }, []);

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}><CircularProgress size={24} /></Box>;
  if (error) return <Box sx={{ color: 'error.main' }}>{error}</Box>;

  return (
    <Box sx={{ fontSize: 14 }}>
      <div>Account SID: <strong>{maskSid(data?.accountSid)}</strong></div>
      <div>Project Name: <strong>{data?.projectName || '—'}</strong></div>
      <div>Subaccount SID: <strong>{maskSid(data?.subaccountSid)}</strong></div>
      <div>Twilio Console: <Link href="https://console.twilio.com/" target="_blank" rel="noreferrer">Open</Link></div>
      {data?.balance && <div>Balance: <strong>{data.balance}</strong></div>}
      {data?.monthlyUsage && <div>Monthly Usage: <strong>{data.monthlyUsage}</strong></div>}
    </Box>
  );
}
